<button
  type="button"
  class="tab-button"
  [class.active]="isActive()"
  [class.disabled]="isDisabled()"
  [disabled]="isDisabled()"
  (click)="tabClicked.emit($event)"
>
  @if (iconClass()) {
    <i [class]="'icon ' + iconClass()"></i>
  }

  <span class="content">
    <ng-content/>
  </span>
</button>
